"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _underscore = require("underscore");

var _immutable = _interopRequireDefault(require("immutable"));

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _InitialFilterParams = _interopRequireDefault(require("../constants/InitialFilterParams"));

var _requestStatus = require("../constants/propTypes/requestStatus");

var _SearchBar = _interopRequireDefault(require("../components/SearchBar"));

var _searchBarUtils = require("../utils/searchBarUtils");

var GoodsActions = _interopRequireWildcard(require("../actions/GoodsActions"));

var _providers = require("../selectors/providers");

var SearchBarContainer = _react.default.createClass({
  displayName: "SearchBarContainer",
  propTypes: {
    allProviders: _react.PropTypes.array.isRequired,
    appliedSearchTerm: _react.PropTypes.string,
    autocomplete: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
    categoryFilter: _react.PropTypes.string.isRequired,
    fetchForAutocomplete: _react.PropTypes.func.isRequired,
    fetchMatchingSearchResults: _react.PropTypes.func.isRequired,
    fetchProviders: _react.PropTypes.func.isRequired,
    goodFilters: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
    goToGoodSearchOption: _react.PropTypes.func.isRequired,
    hideAutocompleteMenu: _react.PropTypes.func.isRequired,
    providersRequestStatus: _requestStatus.requestStatusPropType.isRequired,
    screen: _react.PropTypes.string.isRequired
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.debouncedFetchForAutocomplete = (0, _underscore.debounce)(this.props.fetchForAutocomplete, 100);
  },
  componentDidMount: function componentDidMount() {
    window.addEventListener('click', this.handleWindowClick);
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('click', this.handleWindowClick);
  },
  handleWindowClick: function handleWindowClick(evt) {
    var searchBarDOMNode = _reactDom.default.findDOMNode(this.searchBar);

    if (searchBarDOMNode && !searchBarDOMNode.contains(evt.target)) {
      this.props.hideAutocompleteMenu();
    }
  },
  handleSidebarFilterSelection: function handleSidebarFilterSelection(value) {
    var _extends2;

    this.props.fetchMatchingSearchResults((0, _extends3.default)((_extends2 = {}, (0, _defineProperty2.default)(_extends2, _GoodFiltersAndPage.default.SEARCH_TERM, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.SEARCH_TERM)), (0, _defineProperty2.default)(_extends2, _GoodFiltersAndPage.default.PAGE, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.PAGE)), _extends2), (0, _searchBarUtils.getSidebarFiltersFromOptionValue)(value)), this.props.screen);
  },
  handleFilterByNameSelection: function handleFilterByNameSelection(searchTerm) {
    var _this$props$fetchMatc;

    this.props.fetchMatchingSearchResults((_this$props$fetchMatc = {}, (0, _defineProperty2.default)(_this$props$fetchMatc, _GoodFiltersAndPage.default.PAGE, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.PAGE)), (0, _defineProperty2.default)(_this$props$fetchMatc, _GoodFiltersAndPage.default.SEARCH_TERM, searchTerm), _this$props$fetchMatc), this.props.screen);
  },
  handleGoodSelection: function handleGoodSelection(goodUrlToken) {
    this.props.goToGoodSearchOption(goodUrlToken, this.props.screen);
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        allProviders = _this$props.allProviders,
        appliedSearchTerm = _this$props.appliedSearchTerm,
        autocomplete = _this$props.autocomplete,
        categoryFilter = _this$props.categoryFilter,
        fetchProviders = _this$props.fetchProviders,
        goodFilters = _this$props.goodFilters,
        providersRequestStatus = _this$props.providersRequestStatus;
    return _react.default.createElement(_SearchBar.default, {
      ref: function ref(_ref) {
        _this.searchBar = _ref;
      },
      allProviders: allProviders,
      appliedSearchTerm: appliedSearchTerm || '',
      autocomplete: autocomplete,
      categoryFilter: categoryFilter,
      debouncedFetchForAutocomplete: this.debouncedFetchForAutocomplete,
      fetchProviders: fetchProviders,
      goodFilters: goodFilters,
      onFilterByNameSelection: this.handleFilterByNameSelection,
      onGoodSelection: this.handleGoodSelection,
      onSidebarFilterSelection: this.handleSidebarFilterSelection,
      providersRequestStatus: providersRequestStatus
    });
  }
});

function mapStateToProps(state) {
  return {
    allProviders: (0, _providers.getProviderNames)(state),
    autocomplete: state.autocomplete,
    goodFilters: state.directoryData.get('goodFiltersAndPage'),
    providersRequestStatus: (0, _providers.getProvidersRequestStatus)(state)
  };
}

var mapDispatchToProps = {
  fetchForAutocomplete: GoodsActions.fetchForAutocomplete,
  fetchMatchingSearchResults: GoodsActions.fetchMatchingSearchResults,
  fetchProviders: GoodsActions.getProviderNames,
  goToGoodSearchOption: GoodsActions.goToGoodSearchOption,
  hideAutocompleteMenu: GoodsActions.hideAutocompleteMenu
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchBarContainer);

exports.default = _default;
module.exports = exports.default;